module.exports = __webpack_public_path__ + "img/icon-star-empty.1274e779.svg";